import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectPbmHeaderKey = createSelector(
  [selectPartner360Data],
  ({ pbmHeaderKey }) => pbmHeaderKey
)
